import { render, staticRenderFns } from "./dataResourcesEntry.vue?vue&type=template&id=c9b437cc&scoped=true"
import script from "./dataResourcesEntry.vue?vue&type=script&lang=js"
export * from "./dataResourcesEntry.vue?vue&type=script&lang=js"
import style0 from "./dataResourcesEntry.vue?vue&type=style&index=0&id=c9b437cc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9b437cc",
  null
  
)

export default component.exports